module.exports = __webpack_public_path__ + "img/phone.550d1112.jpg";